export const getShortLanguageCode = (language) => language.substr(0, 2);
